import React, { useEffect, useState } from "react";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import TagOrder from "./component";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AlreadyScanned from "./AlreadyScanned";
import { useDispatch, useSelector } from "react-redux";
import { useWebSocket } from "../../Websocket/useWebSocket";
import { setWebSocketData } from "../../Websocket/webSocketAction";
import PaymentStatus from "./PaymentStatus/Component";
import CouponList from "./buyOrder/CouponList";
import { Box } from "@material-ui/core";
import ApplyCouponPopUp from "./ApplyCouponPopUp";
import backArrow from '../../assets/backArrow.png'
import NoCoupons from "./NoCoupon";
import DaalchiniLogo from '../../assets/dalchini_icon.png'
import { set } from "date-fns";
const TagOrderContainer = () => {
  const location = useLocation()
        const ReduxOrderData = useSelector(
      (state) => state.WebSocket?.OrderData
    );
    const { makeApiRequest } = useApiRequest();
       const dispatch = useDispatch()
    const { wsData, startWebSocket } = useWebSocket()
  const params = new URLSearchParams(location.search);
   const str = params.get("value");
  const value = str.split("?")[0];
  //const value = params.get("value");
    const navigate = useNavigate()


    console.log("tahzeeb---",value)
  const [paymentStatusFlag,setPaymentStatusFlag]=useState(false)

  const [loader, setLoader] = useState(false);
  const [reward,setReward]=useState(null)
  const [couponsList,setCouponsList]=useState(null)
  const [couponAppliedSuccess,setCouponAppliedSuccess]=useState(false)
  const [showCouponPopFlag,setShowCouponPopFlag]=useState(false)
  const [orderSucessStatus,setOrderSucessStatus]=useState(false)
  const [orderSucessPaymentMethod,setOrderSucessPaymentMethod]=useState(null)
  const [orderSucessOrderId,setOrderSucessOrderId]=useState(null)
  const [balance,setBalance]=useState(null)   
 const [couponCode,setCouponCode]=useState("tahzeeb")

const [machineId,setMachineId]=useState(null)


  const fetchCoupon = () => {
    //console.log("value",value)
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    if (!UserJWTAuth || !value) {
      //console.error("Missing UserJWTAuth or orderId");
      //return;
    }

    setLoader(true);

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/kiosk/post-order/coupon?orderId=${value}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      
      handleSuccess: handleResponseCoupon,
      handleError: handleErrorCoupon,
    });
  };

const handleResponseCoupon=(res)=>{
//console.log("coupon lise",res)
setCouponsList(res.data.data)
}

const handleErrorCoupon=()=>{

}


  const Claim = () => {
    // console.log("value",value)
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    if (!UserJWTAuth || !value) {
      //console.error("Missing UserJWTAuth or orderId");
      //return;
    }

    setLoader(true);

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/user/loyalty/${value}/eligible`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      data: {
       
      },
      handleSuccess: handleResponseClaim,
      handleError: handleErrorClaim,
    });
  };

  const handleResponseClaim=()=>{

  }

  const handleErrorClaim=()=>{

  }

  const fetchLoyalty = () => {
    // console.log("value",value)
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    if (!UserJWTAuth || !value) {
      //console.error("Missing UserJWTAuth or orderId");
      //return;
    }

    setLoader(true);

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/user/loyalty/${value}/tag`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      data: {
       
      },
      handleSuccess: handleResponseLoyalty,
      handleError: handleErrorLoyalty,
    });
  };

  const handleResponseLoyalty = (res) => {
    console.log("res.data.data.balance",res.data.data.balance)
    setLoader(false);
    setReward(res.data.data)
    setMachineId(res.data.data.machineId)
    setBalance(res.data.data.balance)
  };

  const handleErrorLoyalty = (err) => {
    //console.error("Loyalty Tag Error:", err.response.data.status.code);
    setReward(false)
    if(err.response.data.status.code=="UNAUTHORIZED"){

      navigate(`/login?route=tagOrderId?value=${value}`)

    }
    if(err.response.data.status.code=="ACCESS_DENIED"){

      navigate(`/login?route=tagOrderId?value=${value}`)
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchLoyalty();
    fetchCoupon()
    Claim()
  }, [value]);


  const ApplyCoupon = (id,name) => {
    //console.log("value",value)
    setCouponCode(name)
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    if (!UserJWTAuth || !value) {
      //console.error("Missing UserJWTAuth or orderId");
      //return;
    }

    setLoader(true);

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/kiosk/post-order/coupon`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      data:{
        "couponId":id,
        "orderId": value
      },
      
      handleSuccess: handleResponseApplyCoupon,
      handleError: handleErrorApplyCoupon,
    });
  };

const handleResponseApplyCoupon=(res)=>{
//console.log("coupon lise",res)
//setCouponsList(res.data.data)
setLoader(false)
setCouponAppliedSuccess(true)
}

const handleErrorApplyCoupon=(error)=>{

//console.log("error------------------",error)
//setCouponText("hello")
setCouponAppliedSuccess(false)
 setShowCouponPopFlag(true)
 setLoader(false)


}


const handleCloseCouponPopup=()=>{

setCouponAppliedSuccess(false)
 setShowCouponPopFlag(false)
}
const CouponText = () => {
  return (
    <>
      {couponAppliedSuccess == true && (
        <p>Your coupon Claimed successfully!</p>
      )}

      {showCouponPopFlag ==true && (
        <p>
          {/* Coupon code <strong>{couponCode}</strong> does not exist for this
          item. Please try again! */}
          Something went wrong. Please try again later
        </p>
      )}
    </>
  );
};


if(reward==false){
    return <AlreadyScanned/>
}

const applyCoupon=(e,id,name)=>{
   // console.log("coupon id",id)
    ApplyCoupon(id,name)

}

  const handleStartWebSocket = (orderId) => {
   
    const url = `wss://api-prod.daalchini.co.in/consumerbe/status/payment?order_id=${orderId}`;


    startWebSocket(url, (data, navigate) => {
      //console.log("WebSocket received:", data);
      
      dispatch(setWebSocketData(data));
      setPaymentStatusFlag(true)
      setOrderSucessStatus(data?.success)
      setOrderSucessOrderId(data?.orderId)
      setOrderSucessPaymentMethod(data?.pgName)
      setLoader(false)

  

      
    });
  };
const MyHeader = ({ handleBack, }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      sx={{
        background: "#fae14b",
        position: "fixed",
        width: "100%",
        zIndex: 999,
      }}
    >
         <Box
        component="img"
        src={backArrow}
        alt="Logo"
        sx={{ width: 22, height: 18, ml: 1 }}
        onClick={handleBack}
      />

      {/* Add Image */}
      <Box
        component="img"
        src={DaalchiniLogo}
        alt="Logo"
        sx={{ width: 100, height: 40, ml: 1 }}
      />

   
    </Box>
  );
};

  const handleBack=()=>{
navigate(`/`)
  }

  const RedirectAfterPaymentStatus=()=>{
navigate(`/pickupOptions/${ReduxOrderData.orderId}`)

}
    //console.log("orderSucessOrderId",orderSucessOrderId)
  return (
    <>

<MyHeader handleBack={handleBack}/>
              {showCouponPopFlag&& <ApplyCouponPopUp
            CouponText={CouponText}
            handleCloseCouponPopup={handleCloseCouponPopup}
            couponAppliedSuccess={couponAppliedSuccess}
            machineId={machineId}
          />}

              {couponAppliedSuccess&& <ApplyCouponPopUp
            CouponText={CouponText}
            handleCloseCouponPopup={handleCloseCouponPopup}
            couponAppliedSuccess={couponAppliedSuccess}
            machineId={machineId}
          />}
  {reward&&reward?
    
    <>
         {paymentStatusFlag?    
         <PaymentStatus onTimerComplete={RedirectAfterPaymentStatus}   status={setOrderSucessStatus}
      amount ={"100"}
      orderId ={orderSucessOrderId}  paymentMethod={orderSucessPaymentMethod} />:
      <TagOrder loader={loader}  
      reward={reward} 
      couponsList={couponsList}
       applyCoupon={applyCoupon} 
       couponAppliedSuccess={couponAppliedSuccess}
       showCouponPopFlag={showCouponPopFlag}
       handleCloseCouponPopup={handleCloseCouponPopup}
       CouponText={CouponText}
       handleStartWebSocket={handleStartWebSocket}
       setPaymentStatusFlag={setPaymentStatusFlag}
       paymentStatusFlag={paymentStatusFlag}
     machineId={machineId}
     balance={balance}
       
       />
         }
    </>:<>
  {couponsList?.length > 0 ? (
  <Box sx={{ p: "20px", background: "white" }}>
    <CouponList couponsList={couponsList} applyCoupon={applyCoupon}  marginTop={"50px"}/>
  </Box>
) : (
  <>
{/*   <NoCoupons machineId={machineId} /> */}
  </>
)}

    </>}
    </>
  );
};

export default TagOrderContainer;
